module.exports = __webpack_public_path__ + "static/media/kaardirakendus.c30d9852.svg";